(function ($) {

  $(document).ready(function () {
    var $video_with_text = $('body .video-with-text .video-text .bg-img img');
    objectFitImages($video_with_text);
  });

  $(window).on('load', function () {
    $('.video-with-text .slider-wrap .slider .col-two').matchHeight({byRow: 0});
    var value = $('.video-with-text').attr('data-slide');
if (value == 'True') {
    $('.video-with-text .slider-wrap .slider').slick({
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      draggable: false,
      autoplay: true,
      speed: 800,
      fade: false,
      speed: 800,
      prevArrow: $('.video-with-text .slide-nav .slide-prev'),
      nextArrow: $('.video-with-text .slide-nav .slide-next')
    });
  }else{
    $('.video-with-text .slider-wrap .slider').slick({
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      draggable: false,
      fade: false,
      speed: 800,
      prevArrow: $('.video-with-text .slide-nav .slide-prev'),
      nextArrow: $('.video-with-text .slide-nav .slide-next')
    });
  }

    $('.video-with-text .slider-wrap .slider').css({"opacity": 1});
  });

})(jQuery);
